<template>
  <div class="blocks-palette">
    <div class="blocks-palette-header">
      <h2>Elements</h2>
      <input 
        v-model="searchQuery"
        type="text" 
        class="blocks-search" 
        placeholder="Search elements..."
      />
    </div>
    
    <div 
      v-for="category in filteredCategories" 
      :key="category.name"
      class="blocks-category"
    >
      <div class="blocks-category-title">{{ category.name }}</div>
      <div class="blocks-grid">
        <div 
          v-for="block in category.blocks" 
          :key="block.type"
          class="block-item"
          draggable="true"
          @dragstart="onDragStart($event, block)"
          @click="$emit('add-element', block.type)"
          :title="`Click or drag to add ${block.label}`"
        >
          <div class="block-item-icon">{{ block.icon }}</div>
          <div class="block-item-label">{{ block.label }}</div>
        </div>
      </div>
    </div>
    
    <div v-if="filteredCategories.length === 0" class="empty-state">
      <p>No elements found</p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const emit = defineEmits(['add-element']);

const searchQuery = ref('');

const categories = [
  {
    name: 'Content',
    blocks: [
      { type: 'text', label: 'Text', icon: '📝', description: 'Text paragraph or heading' },
      { type: 'image', label: 'Image', icon: '🖼️', description: 'Image with optional link' },
      { type: 'links', label: 'Links', icon: '🔗', description: 'List of links' },
      { type: 'html', label: 'HTML', icon: '💻', description: 'Custom HTML code' }
    ]
  },
  {
    name: 'Social',
    blocks: [
      { type: 'social', label: 'Social Icons', icon: '👥', description: 'Social media icons' }
    ]
  },
  {
    name: 'Forms',
    blocks: [
      { type: 'newsletter', label: 'Newsletter', icon: '📧', description: 'Email subscription form' }
    ]
  },
  {
    name: 'Navigation',
    blocks: [
      { type: 'menu', label: 'Menu', icon: '📋', description: 'Navigation menu' }
    ]
  },
  {
    name: 'Layout',
    blocks: [
      { type: 'divider', label: 'Divider', icon: '➖', description: 'Horizontal line' },
      { type: 'spacer', label: 'Spacer', icon: '⬜', description: 'Empty space' }
    ]
  }
];

const filteredCategories = computed(() => {
  if (!searchQuery.value) return categories;
  
  const query = searchQuery.value.toLowerCase();
  return categories.map(cat => ({
    ...cat,
    blocks: cat.blocks.filter(block => 
      block.label.toLowerCase().includes(query) ||
      block.description.toLowerCase().includes(query)
    )
  })).filter(cat => cat.blocks.length > 0);
});

function onDragStart(event, block) {
  event.dataTransfer.effectAllowed = 'copy';
  event.dataTransfer.setData('block-type', block.type);
  event.dataTransfer.setData('text/plain', block.type); // Fallback
  
  // Add visual feedback
  event.target.style.opacity = '0.5';
  setTimeout(() => {
    event.target.style.opacity = '1';
  }, 0);
}
</script>

